// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import SidebarHeader from './sidebar_header';

export default SidebarHeader;
